import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isUserLoading: false,
  user: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserLoading(state, action) {
      state.isUserLoading = action.payload;
    },
    setUser(state, action) {
      state.user = action.payload;
      state.isUserLoading = false;
    },
  },
});

export const { setUserLoading, setUser } = userSlice.actions;

export default userSlice.reducer;
